"use client";

import { cn } from "@/lib/utils";
import { PlayerAvatar, TeamLogo } from "@/components/ui/avatar";
import { matchupSides, opponentLine, teamLogoUrl } from "./labels";
import type { Subject } from "./subject";

const FRAME = "flex min-w-0 items-center gap-2.5";
const TEXT = "flex min-w-0 flex-col justify-center";
const TITLE = "truncate text-[13px] font-medium text-foreground";
const SUBTITLE = "truncate text-[11px] text-zinc-500";

export function SubjectCell({ subject, className }: { subject: Subject; className?: string }) {
  switch (subject.kind) {
    case "player":
      return (
        <div className={cn(FRAME, className)}>
          <PlayerAvatar name={subject.name} imageUrl={subject.imageUrl} size={32} />
          <div className={TEXT}>
            <span className={TITLE}>{subject.name}</span>
          </div>
        </div>
      );
    case "team":
      return (
        <div className={cn(FRAME, className)}>
          <TeamLogo name={subject.name} imageUrl={teamLogoUrl(subject.event, subject.name)} size={32} />
          <div className={TEXT}>
            <span className={TITLE}>{subject.name}</span>
            <span className={SUBTITLE}>{opponentLine(subject.event, subject.name, subject.league)}</span>
          </div>
        </div>
      );
    case "result":
      return (
        <div className={cn("flex min-w-0 items-center", className)}>
          <span title={subject.name} className="line-clamp-2 break-words text-[13px] font-medium leading-4 text-foreground">{subject.name}</span>
        </div>
      );
    case "game":
      return (
        <div className={cn("flex min-w-0 flex-col justify-center gap-1", className)}>
          {matchupSides(subject.event, ["away", "home"]).map(({ line, name, logo }) => (
            <span key={line} className="flex min-w-0 items-center gap-2">
              {subject.event && <TeamLogo name={name} imageUrl={logo} size={20} />}
              <span className={TITLE}>{name}</span>
            </span>
          ))}
        </div>
      );
  }
}
